var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-medium-size-100 md-size-100"},[_c('md-card',[_c('md-card-header',{attrs:{"data-background-color":"purple"}},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.$route.name))])]),_c('md-card-content',[_c('router-view')],1)],1)],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3954c3fd","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Administrators.vue
// module id = null
// module chunks = 